/**
 * Liefert das Piktogramm einer Positions-Metainformation anhand ihres descriptionType.
 * Identische Zuordnung wie im Schema-Tab (avs-line-name).
 */
export function getPositionPiktogramm(descriptionType: number | null | undefined): string | null {
  switch (descriptionType) {
    case 1: return 'assets/piktogramme/parkplatz.svg';
    case 4: return 'assets/piktogramme/ausfahrt_autobahn.svg';
    case 5: return 'assets/piktogramme/ausfahrt_bundesstrasse.svg';
    case 6: return 'assets/piktogramme/autobahnkreuz.svg';
    case 7: return 'assets/icons/camera/icon_lichtschranke_empfaenger_1.svg';
    case 8: return 'assets/icons/camera/icon_lichtschranke_sender_1.svg';
    case 9: return 'assets/icons/camera/icon_lichtschranke_empfaenger_2.svg';
    case 10: return 'assets/icons/camera/icon_lichtschranke_sender_2.svg';
    default: return null;
  }
}
